import { create } from 'zustand'

export type Theme = 'dark' | 'light' | 'hack'

interface ThemeState {
  theme: Theme
  setTheme: (theme: Theme) => void
}

function applyTheme(theme: Theme) {
  document.documentElement.setAttribute('data-theme', theme)
  localStorage.setItem('synapsios_theme', theme)
}

const savedTheme = (typeof localStorage !== 'undefined' ? localStorage.getItem('synapsios_theme') : null) as Theme | null

export const useThemeStore = create<ThemeState>((set) => ({
  theme: savedTheme || 'dark',
  setTheme: (theme: Theme) => {
    applyTheme(theme)
    set({ theme })
  },
}))

// Apply theme on load
if (typeof document !== 'undefined') {
  applyTheme(savedTheme || 'dark')
}
